import RenderLayout from "./components/RenderLayout"

export default function CustomSessionTemplate1() {
  console.log("CustomFormTemplate1")
  const ID_TEMPLATE = "custom_session_template_1"
  const ID_BLOCKS = ["default__custom__block_1", "session"]
  const listViewCols = [
    {
      header: "Date",
      field: "session_date",
      block: "session",
      type: "date",
    },
    {
      header: "Submitted By",
      field: "staff_full_name",
      block: "session",
      type: "staff",
    },
  ]
  return (
    <RenderLayout
      ID_TEMPLATE={ID_TEMPLATE}
      ID_BLOCKS={ID_BLOCKS}
      listViewCols={listViewCols}
    />
  )
}
